import config from "./config";
var axios = config();

export default {
  // get
  getStudentByAsuriteId(asuriteId) {
    return axios.get("/api/Students/" + asuriteId);
  },

  getStudentCourses(asuriteId) {
    return axios.get("/api/Students/GetStudentCourses/" + asuriteId);
  }
};
